import clsx from 'clsx';
import HelperText from './shared/HelperText';
import ErrorText from './shared/ErrorText';
import {Input} from '@/shadcn_components/ui/input';
import {Label} from '@/shadcn_components/ui/label';
import {InputProps, useInput} from '../../hooks/useInput';
import {cn} from '@/lib/tailwind-utils';

export type TextInputProps = InputProps & Partial<React.ComponentProps<'input'>>;

const TextInput = (props: TextInputProps) => {
  const {field, fieldState} = useInput(props);
  const {className, hidden, label, type} = props;
  const {value = '', onBlur, onChange, name, disabled, ref} = field;

  return (
    <div className={cn('w-full space-y-1', className)} hidden={hidden}>
      <Label
      // className='text-lg'
      >
        {label}
      </Label>
      <Input
        // className='text-lg'
        name={name}
        type={type}
        value={value}
        disabled={disabled}
        onChange={onChange}
        ref={ref}
        onBlur={onBlur}
        readOnly={props.readOnly}
      />
      <HelperText helperText={props.helperText} />
      <ErrorText {...fieldState} />
    </div>
  );
};

export default TextInput;
